// import React, { useEffect, useState, useContext } from "react";
// import toast from "react-hot-toast";
// import { useNavigate, useParams } from "react-router-dom";
// import RoomGallery from "../../components/listings/RoomGallery";
// import AmenitiesBadge from "../../components/listings/AmenitiesBadge";
// import Button from "../../components/common/Button";
// import api from "../../utils/api";
// import { getImageUrl } from "../../utils/imageUrl";
// import { AuthContext } from "../../context/AuthContext";

// export default function RoomDetailsPage() {
//   const { id } = useParams();
//   const [listing, setListing] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const { user } = useContext(AuthContext);
//   const nav = useNavigate();

//   useEffect(() => {
//     async function load() {
//       try {
//         const res = await api.get(`/listings/${id}`);
//         setListing(res.data);
//       } catch (err) {
//         console.error(err);
//         toast.error("Failed to load room");
//       } finally {
//         setLoading(false);
//       }
//     }
//     load();
//   }, [id]);

//   async function startDeal() {
//     if (!user) {
//       toast.error("Please login as a seeker to start a deal");
//       nav("/login");
//       return;
//     }
//     if (user.role !== "SEEKER") {
//       toast.error("Only seekers can initiate deals");
//       return;
//     }
//     try {
//       const res = await api.post("/deals/initiate", {
//         listingId: listing.id,
//       });
//       nav(`/deal/${res.data.id}`);
//     } catch (err) {
//       toast.error(err?.response?.data?.message || "Failed to initiate deal");
//     }
//   }

//   function openChat() {
//     if (!user) {
//       toast.error("Please login to chat with the owner");
//       nav("/login");
//       return;
//     }
//     nav(`/messages?withUserId=${listing.owner.id}&listingId=${listing.id}`);
//   }

//   if (loading) {
//     return (
//       <div className="max-w-6xl mx-auto px-6 py-10">Loading...</div>
//     );
//   }

//   if (!listing) {
//     return (
//       <div className="max-w-6xl mx-auto px-6 py-10">
//         Room not found.
//       </div>
//     );
//   }

//   const images =
//     listing.images?.length > 0
//       ? listing.images
//       : ["/images/sample.jpg"];

//   return (
//     <div className="max-w-6xl mx-auto px-6 py-10 grid grid-cols-3 gap-8">
//       {/* LEFT SIDE */}
//       <div className="col-span-2 space-y-6">
//         {/* IMAGE GALLERY */}
//         {/* <RoomGallery images={images} /> */}
//         <RoomGallery
//           images={images}
//           video={listing.video}
//         />

//         {/* BASIC INFO */}
//         <div className="bg-white p-6 rounded-2xl">
//           <h1 className="text-2xl font-bold mb-1">
//             {listing.title}
//           </h1>
//           <p className="text-gray-500 mb-4">
//             {listing.location}
//           </p>

//           {listing.description && (
//             <p className="text-gray-700 mb-4">
//               {listing.description}
//             </p>
//           )}

//           <ul className="flex flex-wrap gap-2 mb-4">
//             {listing.facilities?.map((f) => (
//               <AmenitiesBadge key={f}>{f}</AmenitiesBadge>
//             ))}
//           </ul>

//           <p className="text-gray-700 text-sm">
//             Rooms: {listing.rooms} • Kitchen:{" "}
//             {listing.kitchen ? "Yes" : "No"} • Bathroom:{" "}
//             {listing.bathroom ? "Yes" : "No"}
//           </p>
//         </div>

//         {/* AVAILABILITY */}
//         <div className="bg-white p-6 rounded-2xl">
//           <h3 className="font-semibold mb-3">
//             Availability & Lease
//           </h3>
//           <ul className="text-sm text-gray-700 space-y-1">
//             <li>
//               <strong>Available From:</strong>{" "}
//               {listing.availableFrom
//                 ? new Date(listing.availableFrom).toDateString()
//                 : "Not specified"}
//             </li>
//             <li>
//               <strong>Lease Duration:</strong>{" "}
//               {listing.leaseDuration || "Flexible"}
//             </li>
//           </ul>
//         </div>

//         {/* NEIGHBORHOOD */}
//         {listing.neighborhood && (
//           <div className="bg-white p-6 rounded-2xl">
//             <h3 className="font-semibold mb-2">Neighborhood</h3>
//             <p className="text-sm text-gray-700">
//               {listing.neighborhood}
//             </p>
//           </div>
//         )}

//         {/* RULES & INFO */}
//         <div className="bg-white p-6 rounded-2xl space-y-4">
//           {listing.houseRules && (
//             <div>
//               <h3 className="font-semibold mb-1">House Rules</h3>
//               <p className="text-sm text-gray-700">
//                 {listing.houseRules}
//               </p>
//             </div>
//           )}

//           {listing.additionalInfo && (
//             <div>
//               <h3 className="font-semibold mb-1">
//                 Additional Information
//               </h3>
//               <p className="text-sm text-gray-700">
//                 {listing.additionalInfo}
//               </p>
//             </div>
//           )}
//         </div>
//       </div>

//       {/* RIGHT SIDE */}
//       <aside className="space-y-4">
//         {/* PRICE CARD */}
//         <div className="bg-white p-6 rounded-2xl shadow">
//           <p className="text-gray-500 text-sm">Monthly Rent</p>
//           <p className="text-3xl font-bold text-primary mt-1">
//             Rs. {listing.rentAmount}
//           </p>

//           {listing.securityDeposit && (
//             <p className="text-sm text-gray-600 mt-1">
//               Security Deposit: Rs. {listing.securityDeposit}
//             </p>
//           )}

//           {listing.utilitiesIncluded && (
//             <p className="text-sm text-gray-600 mt-1">
//               Utilities: {listing.utilitiesIncluded}
//             </p>
//           )}

//           <div className="mt-6 flex gap-3">
//             <Button variant="primary" onClick={startDeal}>
//               Confirm Deal
//             </Button>
//             <Button variant="outline" onClick={openChat}>
//               Chat with Owner
//             </Button>
//           </div>
//         </div>

//         {/* OWNER INFO */}
//         <div className="bg-white p-6 rounded-2xl">
//           <h4 className="font-semibold">Room Owner</h4>
//           <div className="mt-3 text-sm">
//             {listing.owner?.fullName || "Owner"}
//             <br />
//             <span className="text-gray-500">
//               Verified Owner
//             </span>
//           </div>
//         </div>
//       </aside>
//     </div>
//   );
// }

import React, { useEffect, useState, useContext } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";

import RoomGallery from "../../components/listings/RoomGallery";
import AmenitiesBadge from "../../components/listings/AmenitiesBadge";
import Button from "../../components/common/Button";

import api from "../../utils/api";
import { getImageUrl } from "../../utils/imageUrl";
import { AuthContext } from "../../context/AuthContext";

/*
|--------------------------------------------------------------------------
| Advertisement Component
|--------------------------------------------------------------------------
*/

function Advertisement({
  src,
  alt = "Advertisement",
  href = "#",
  position = "horizontal",
}) {
  const isHorizontal = position === "horizontal";

  return (
    <div
      className={`w-full ${
        isHorizontal ? "max-w-[1200px]" : "max-w-[300px]"
      } mx-auto`}
    >
      <div className="relative group">
        <a
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="block"
        >
          <img
            src={src}
            alt={alt}
            className={`
              w-full
              object-cover
              rounded-xl
              border
              border-gray-200
              transition
              duration-300
              group-hover:shadow-md
            ${isHorizontal ? "h-[90px]" : "h-[250px]"}
            `}
          />
        </a>
      </div>

      {/* Advertisement dimensions */}
      <p className="text-center text-[11px] text-gray-400 mt-1">
        {isHorizontal ? "1200 × 90 px" : "300 × 250 px"}
      </p>
    </div>
  );
}

/*
|--------------------------------------------------------------------------
| Room Details Page
|--------------------------------------------------------------------------
*/

export default function RoomDetailsPage() {
  const { id } = useParams();

  const [listing, setListing] = useState(null);
  const [loading, setLoading] = useState(true);

  const { user } = useContext(AuthContext);

  const nav = useNavigate();

  /*
  |--------------------------------------------------------------------------
  | Load Listing
  |--------------------------------------------------------------------------
  */

  useEffect(() => {
    async function load() {
      try {
        const res = await api.get(`/listings/${id}`);

        setListing(res.data);
      } catch (err) {
        console.error(err);

        toast.error("Failed to load room");
      } finally {
        setLoading(false);
      }
    }

    load();
  }, [id]);

  /*
  |--------------------------------------------------------------------------
  | Start Deal
  |--------------------------------------------------------------------------
  */

  async function startDeal() {
    if (!user) {
      toast.error("Please login as a seeker to start a deal");

      nav("/login");

      return;
    }

    if (user.role !== "SEEKER") {
      toast.error("Only seekers can initiate deals");

      return;
    }

    try {
      const res = await api.post("/deals/initiate", {
        listingId: listing.id,
      });

      nav(`/deal/${res.data.id}`);
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to initiate deal");
    }
  }

  /*
  |--------------------------------------------------------------------------
  | Open Chat
  |--------------------------------------------------------------------------
  */

  function openChat() {
    if (!user) {
      const redirectURL =
        `/messages?withUserId=${listing.owner.id}` + `&listingId=${listing.id}`;

      nav(`/login?redirect=${encodeURIComponent(redirectURL)}`);

      return;
    }

    nav(
      `/messages?withUserId=${listing.owner.id}` + `&listingId=${listing.id}`,
    );
  }

  /*
  |--------------------------------------------------------------------------
  | Loading
  |--------------------------------------------------------------------------
  */

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-gray-500">Loading room...</p>
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | Not Found
  |--------------------------------------------------------------------------
  */

  if (!listing) {
    return (
      <div className="max-w-6xl mx-auto px-6 py-10">
        <div className="bg-white rounded-2xl p-10 text-center">
          <h2 className="text-xl font-semibold">Room not found</h2>

          <p className="text-gray-500 mt-2">
            This room may have been removed or is no longer available.
          </p>
        </div>
      </div>
    );
  }

  /*
  |--------------------------------------------------------------------------
  | Images
  |--------------------------------------------------------------------------
  */

  const images =
    listing.images?.length > 0 ? listing.images : ["/images/sample.jpg"];

  return (
    <div className="bg-[#f8f8f8] min-h-screen">
      <div className="max-w-[1200px] mx-auto px-4 sm:px-6 py-6">
        {/* ============================================================
            TOP ADVERTISEMENT
        ============================================================ */}

        <div className="mb-5">
          <Advertisement
            src="/images/advertisements/detailsPage/top-ad.jpeg"
            alt="RoomVetiyo Advertisement"
            href="#"
            position="horizontal"
          />
        </div>

        {/* ============================================================
            MAIN CONTENT
        ============================================================ */}

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
          {/* ==========================================================
              LEFT CONTENT
          ========================================================== */}

          <main className="lg:col-span-2 space-y-5">
            {/* ========================================================
                ROOM GALLERY
            ======================================================== */}

            <div className="bg-white rounded-2xl p-3">
              <RoomGallery images={images} video={listing.video} />
            </div>

            {/* ========================================================
                BASIC INFORMATION
            ======================================================== */}

            <div className="bg-white p-6 rounded-2xl">
              {/* Title */}

              <h1 className="text-2xl md:text-3xl font-bold text-gray-900 mb-2">
                {listing.title}
              </h1>

              {/* Location */}

              <div className="flex items-start gap-2 text-gray-500 mb-4">
                <span className="text-orange-500">📍</span>

                <span>{listing.location}</span>
              </div>

              {/* Description */}

              {listing.description && (
                <div className="mb-5">
                  <h3 className="font-semibold text-lg mb-2">Description</h3>

                  <p className="text-gray-700 text-sm leading-6">
                    {listing.description}
                  </p>
                </div>
              )}

              {/* Facilities */}

              {listing.facilities?.length > 0 && (
                <div className="mb-5">
                  <h3 className="font-semibold text-lg mb-3">
                    Facilities & Amenities
                  </h3>

                  <div className="flex flex-wrap gap-2">
                    {listing.facilities.map((facility) => (
                      <AmenitiesBadge key={facility}>{facility}</AmenitiesBadge>
                    ))}
                  </div>
                </div>
              )}

              {/* Room Information */}

              <div className="flex flex-wrap gap-x-5 gap-y-2 text-sm text-gray-700 border-t pt-4">
                <span>
                  <strong>Rooms:</strong> {listing.rooms || 1}
                </span>

                <span>•</span>

                <span>
                  <strong>Kitchen:</strong> {listing.kitchen ? "Yes" : "No"}
                </span>

                <span>•</span>

                <span>
                  <strong>Bathroom:</strong> {listing.bathroom ? "Yes" : "No"}
                </span>
              </div>
            </div>

            {/* ========================================================
                AVAILABILITY & LEASE
            ======================================================== */}

            <div className="bg-white p-6 rounded-2xl">
              <h3 className="font-semibold text-lg mb-4">
                Availability & Lease
              </h3>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500">Available From</p>

                  <p className="font-medium mt-1">
                    {listing.availableFrom
                      ? new Date(listing.availableFrom).toLocaleDateString()
                      : "Not specified"}
                  </p>
                </div>

                <div className="bg-gray-50 rounded-xl p-4">
                  <p className="text-xs text-gray-500">Lease Duration</p>

                  <p className="font-medium mt-1">
                    {listing.leaseDuration || "Flexible"}
                  </p>
                </div>
              </div>
            </div>

            {/* ========================================================
                NEIGHBORHOOD
            ======================================================== */}

            {listing.neighborhood && (
              <div className="bg-white p-6 rounded-2xl">
                <h3 className="font-semibold text-lg mb-2">Neighborhood</h3>

                <p className="text-sm text-gray-700 leading-6">
                  {listing.neighborhood}
                </p>
              </div>
            )}

            {/* ========================================================
                HOUSE RULES
            ======================================================== */}

            {listing.houseRules && (
              <div className="bg-white p-6 rounded-2xl">
                <h3 className="font-semibold text-lg mb-3">House Rules</h3>

                <p className="text-sm text-gray-700 leading-6 whitespace-pre-line">
                  {listing.houseRules}
                </p>
              </div>
            )}

            {/* ========================================================
                ADDITIONAL INFORMATION
            ======================================================== */}

            {listing.additionalInfo && (
              <div className="bg-white p-6 rounded-2xl">
                <h3 className="font-semibold text-lg mb-3">
                  Additional Information
                </h3>

                <p className="text-sm text-gray-700 leading-6 whitespace-pre-line">
                  {listing.additionalInfo}
                </p>
              </div>
            )}

            {/* ========================================================
                BOTTOM HORIZONTAL AD
            ======================================================== */}

            <div className="pt-2">
              <Advertisement
                src="/images/advertisements/detailsPage/bottom-ad.jpeg"
                alt="Internet Advertisement"
                href="#"
                position="horizontal"
              />
            </div>

            {/* ========================================================
                MOBILE OWNER CARD
            ======================================================== */}

            <div className="lg:hidden">
              <div className="bg-white p-6 rounded-2xl">
                <h3 className="font-semibold text-lg">Room Owner</h3>

                <div className="mt-3">
                  <p className="font-medium">
                    {listing.owner?.fullName || "Owner"}
                  </p>

                  <p className="text-sm text-gray-500 mt-1">✓ Verified Owner</p>
                </div>
              </div>
            </div>
          </main>

          {/* ==========================================================
              RIGHT SIDEBAR
          ========================================================== */}

          <aside className="space-y-5">
            {/* ========================================================
                PRICE CARD
            ======================================================== */}

            <div className="bg-white p-6 rounded-2xl shadow-sm">
              <p className="text-gray-500 text-sm">Monthly Rent</p>

              <p className="text-3xl font-bold text-[#FF4A1F] mt-1">
                Rs. {Number(listing.rentAmount).toLocaleString()}
              </p>

              {/* Security Deposit */}

              {listing.securityDeposit && (
                <div className="mt-4">
                  <p className="text-xs text-gray-500">Security Deposit</p>

                  <p className="text-sm font-medium">
                    Rs. {Number(listing.securityDeposit).toLocaleString()}
                  </p>
                </div>
              )}

              {/* Utilities */}

              {listing.utilitiesIncluded && (
                <div className="mt-3">
                  <p className="text-xs text-gray-500">Utilities</p>

                  <p className="text-sm font-medium">
                    {listing.utilitiesIncluded}
                  </p>
                </div>
              )}

              {/* Buttons */}

              <div className="mt-6 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-1 gap-3">
                <Button variant="primary" onClick={startDeal}>
                  Confirm Deal
                </Button>

                <Button variant="outline" onClick={openChat}>
                  Chat with Owner
                </Button>
              </div>
            </div>

            {/* ========================================================
                OWNER CARD
            ======================================================== */}

            <div className="bg-white p-6 rounded-2xl">
              <h4 className="font-semibold text-lg">Room Owner</h4>

              <div className="mt-4">
                <p className="font-medium">
                  {listing.owner?.fullName || "Owner"}
                </p>

                <div className="flex items-center gap-2 mt-2">
                  <span className="w-5 h-5 rounded-full bg-green-500 text-white flex items-center justify-center text-xs">
                    ✓
                  </span>

                  <span className="text-sm text-gray-500">Verified Owner</span>
                </div>
              </div>
            </div>

            {/* ========================================================
                RIGHT SIDEBAR ADVERTISEMENT
            ======================================================== */}

            <Advertisement
              src="/images/advertisements/detailsPage/sidebar-ad.jpeg"
              alt="Furniture Advertisement"
              href="#"
              position="square"
            />
            <Advertisement
              src="/images/advertisements/detailsPage/sidebar-ad.jpeg"
              alt="Furniture Advertisement"
              href="#"
              position="square"
            />
            <Advertisement
              src="/images/advertisements/detailsPage/sidebar-ad.jpeg"
              alt="Furniture Advertisement"
              href="#"
              position="square"
            />
          </aside>
        </div>

        {/* ============================================================
            SIMILAR ROOMS SECTION
        ============================================================ */}

        <div className="mt-8">
          <div className="flex items-center justify-between mb-4">
            <h2 className="text-xl font-semibold">Similar Rooms</h2>

            <button
              type="button"
              onClick={() => nav("/search")}
              className="text-sm font-medium text-gray-700 hover:text-orange-500"
            >
              View All →
            </button>
          </div>

          {/* You can replace this with your actual similar
              room API results later */}

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-4">
            {listing.similarRooms?.map((room) => (
              <div
                key={room.id}
                className="bg-white rounded-xl overflow-hidden border hover:shadow-md transition"
              >
                <img
                  src={getImageUrl(room.images?.[0])}
                  alt={room.title}
                  className="w-full h-32 object-cover"
                />

                <div className="p-3">
                  <p className="text-xs text-orange-500 font-semibold">
                    Rs. {room.rentAmount}
                  </p>

                  <h3 className="font-medium text-sm mt-1 line-clamp-1">
                    {room.title}
                  </h3>

                  <p className="text-xs text-gray-500 mt-1 line-clamp-1">
                    {room.location}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
